/* global Stripe */
import React from 'react';
import styled from 'styled-components';
import * as Three from 'three';
import { CAPanelBody, CAPanelH1, CAPanelH2 } from './ca-panel';
import { Row, Col } from 'antd';
import { CADivider } from './ca-object-details';
import { CAVariableInput } from './ca-variable-input';
import { CASmartToggle } from './ca-smart-toggle';
import StateService from '../../services/state.service';
import EditorService from '../../services/editor.service';
import { CAModalBorderRadius } from './shared';
import { CAMenuBlob } from './ca-menu-blob';
import { navigateTo } from 'gatsby';
import { ComboRow } from './ca-login';

const CAFormMode = {
  off: -1,
  menu: 0,
  projects: 1,
};

export class CAProfileMenu extends React.Component {
  state = {
    mode: CAFormMode.menu,
    newProjectName: '',
    pending: false
  };

  renderMenu() {
    const email = EditorService.getCurrentEmail();

    return (
      <CAPanelBody margin="20px 10px 10px 10px" style={{ overflow: 'visible', width: 200 }}>
        <Row>
          <Col span={24}>
            <CAPanelH1 style={{ display: 'block', margin: '0 auto', textAlign: 'center', width: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {`${email}`.toUpperCase()}
            </CAPanelH1>
          </Col>
        </Row>
        <Row style={{ marginTop: 15 }}>
          <CAMenuBlob onClick={() => {
            if (this.state.pending) {
              return;
            }

            this.setState({ ...this.state, mode: CAFormMode.projects });
          }}>
            My Projects
          </CAMenuBlob>
          <CAMenuBlob onClick={() => {
            if (typeof window === 'undefined') {
              return;
            }

            if (this.state.pending) {
              return;
            }

            this.setState({ ...this.state, mode: CAFormMode.off });

            StateService.clearAll();

            window.location.reload();
          }}>
            Log Out
          </CAMenuBlob>
        </Row>
      </CAPanelBody>
    );
  }

  renderActivateMenu() {
    const email = EditorService.getCurrentEmail();

    return (
      <CAPanelBody margin="20px 10px 10px 10px" style={{ overflow: 'visible', width: 200 }}>
        <Row>
          <Col span={24}>
            <CAPanelH1 style={{ display: 'block', margin: '0 auto', textAlign: 'center', width: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {`${email}`.toUpperCase()}
            </CAPanelH1>
          </Col>
        </Row>
        <Row style={{ marginTop: 15 }}>
          <CAMenuBlob onClick={() => {
            Stripe('pk_live_hlxnxmrHRopZ0GtqRDO5rIQQ').redirectToCheckout({
              lineItems: [{price: 'price_1H10PQJMwJXEniUbo8exvTwU', quantity: 1}],
              mode: 'payment',
              successUrl: window.location.href,
              cancelUrl: window.location.href,
              customerEmail: email,
              clientReferenceId: email,
            });
          }}>
            Activate
          </CAMenuBlob>
          <CAMenuBlob onClick={() => {
            if (typeof window === 'undefined') {
              return;
            }

            if (this.state.pending) {
              return;
            }

            this.setState({ ...this.state, mode: CAFormMode.off });

            StateService.clearAll();

            window.location.reload();
          }}>
            Log Out
          </CAMenuBlob>
        </Row>
      </CAPanelBody>
    );
  }

  renderProjects() {
    const projects = [ 'index', ...(StateService.getSchemaPages() || []) ];

    return (
      <CAPanelBody margin="20px 10px 10px 10px" style={{ overflow: 'visible', width: 340 }}>
        <Row style={{ marginBottom: 10 }}>
          <Col span={24}>
            <CAPanelH1 style={{ display: 'block', margin: '0 auto', textAlign: 'center' }}>
              My Projects
            </CAPanelH1>
          </Col>
        </Row>
        {
          (projects || []).map((name) => (
            <Row style={{ marginBottom: 4 }}>
              <CAVariableInput
                inputType="button"
                span={24}
                onClick={() => {
                  if (typeof window === 'undefined') {
                    return;
                  }

                  if (this.state.pending) {
                    return;
                  }

                  StateService.rememberEditedElement('schemaPage', name, true);

                  if (window.location.pathname !== '/') {                    
                    navigateTo('/');
                  } else {
                    window.location.reload();
                  }
                }}
                inputProps={{
                  style: {
                    textAlign: 'center'
                  }
                }}
              >
                {name !== 'index' ? decodeURIComponent(name) : 'Starting Project'}
              </CAVariableInput>
            </Row>
          ))
        }
        <Row style={{ marginTop: 20 }}>
          <ComboRow span={24}>
            <Row>
              <CAVariableInput
                inputType="text"
                span={18}
                value={this.state.newProjectName}
                inputProps={{
                  placeholder: 'New Project Name',
                  tabindex: 2
                }}
                onChange={(value) => {
                  this.state.newProjectName = value;
                  this.forceUpdate();
                }}
                wrapperProps={{
                  style: {
                    padding: 8,
                    minHeight: 0,
                    borderRadius: 0
                  }
                }}
              />
              <CAVariableInput
                inputType="button"
                span={6}
                onClick={(value) => {
                  if (this.state.pending || !this.state.newProjectName) {
                    return;
                  }

                  this.state.pending = true;
                  this.forceUpdate();

                  const page = encodeURIComponent(this.state.newProjectName);

                  StateService.clearPage(page, [
                    {
                      id: 'env',
                      type: 'environment',
                      backgroundType: 'gradient',
                      backgroundColor: '#1a8d71',
                      backgroundColorB: '#084d86',
                      sunColor: '#fffefa',
                      content: [
                        {
                          id: 'f0',
                          yOffset: 0,
                          type: 'floor',
                          width: 100,
                          height: 100,
                          content: []
                        }
                      ]
                    }
                  ]);
                  StateService.saveAll().then(() => {
                    if (typeof window === 'undefined') {
                      return;
                    }

                    this.state.pending = false;

                    StateService.rememberEditedElement('schemaPage', page, true);

                    if (window.location.pathname !== '/') {                    
                      navigateTo('/');
                    } else {
                      window.location.reload();
                    }
                  });
                }}
                inputProps={{
                  style: {
                    textAlign: 'center'
                  },
                  danger: this.state.newProjectName,
                  pending: this.state.pending,
                  disabled: this.state.pending,
                  tabindex: 3
                }}
              >
                Create
              </CAVariableInput>
            </Row>
          </ComboRow>
        </Row>
      </CAPanelBody>
    );
  }

  render() {
    const { mode } = this.state;
    const email = EditorService.getCurrentEmail();
    const isActive = EditorService.isAccountActive();

    if (!email || mode === CAFormMode.off) {
      return null;
    }

    if (!isActive) {
      return this.renderActivateMenu();
    }

    if (mode === CAFormMode.menu) {
      return this.renderMenu();
    }

    if (mode === CAFormMode.projects) {
      return this.renderProjects();
    }

    return null;
  }
}
